// extracted by mini-css-extract-plugin
export var editButton = "_ob-0";